import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';

import { IWidgetManifest } from '../../../ServicePickerWidget/types/widgetManifest';
import { useAppContext } from '../../../AppModulesWrapper';
import { useTelemetry } from '../../../common/hooks';

export const PaymentWidgetMicrofrontend = () => {
  const { config, logger } = useAppContext();
  const { increment } = useTelemetry();

  const manifest = config.get<IWidgetManifest>('paymentWidgetManifest');

  React.useEffect(() => {
    increment(`paymentWidgetMicrofrontend.render.${manifest ? 'success' : 'fail'}`);
  }, [increment, manifest]);

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Модалки пополнения баланса', {
      domain: 'microfrontends.payment-widget.manifest',
    });

    return null;
  }

  return <Microfrontend {...manifest} />;
};
